import React, { forwardRef } from 'react';
import { DataValueBase, StyledLinkIcon } from './Poppins.styles';

export { Poppins, DataTitle } from './Poppins.styles';

export type PoppinsFontSize = 12 | 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 32 | 36 | 56;

const URL_PATTERN = '(?:https?:\\/\\/|www\\.)[^\\s<>"\')\\]]+';
const URL_REGEX = new RegExp(`(${URL_PATTERN})`, 'gi');

const isUrl = (text: string) => new RegExp(`^${URL_PATTERN}$`, 'i').test(text);

const normalizeHref = (url: string) => (url.startsWith('www.') ? `https://${url}` : url);

export const linkifyText = (text: string): React.ReactNode => {
  const parts = text.split(URL_REGEX);
  return parts.map((part, index) =>
    isUrl(part) ? (
      <a
        key={index}
        href={normalizeHref(part)}
        target="_blank"
        rel="noopener noreferrer"
        className="table-link"
        data-cy="linkified-text"
      >
        {part} <StyledLinkIcon />
      </a>
    ) : (
      part
    ),
  );
};

type DataValueProps = React.ComponentProps<typeof DataValueBase>;

export const DataValue = forwardRef<HTMLSpanElement, DataValueProps>(({ children, ...props }, ref) => {
  const processedChildren = typeof children === 'string' ? linkifyText(children) : children;

  return (
    <DataValueBase ref={ref} {...props}>
      {processedChildren}
    </DataValueBase>
  );
});

DataValue.displayName = 'DataValue';
